import {
    fetchProfile,
    logout,
    deleteAccount,
    registerDeveloper
} from "@/api/index";
import { HOME } from "@/router/path";
import router from "@/router/index";
import i18n from "@/i18n";

const redirect = (currentPath, redirectPath) => {
    if (currentPath !== redirectPath) router.push(redirectPath);
};

export const state = {
    isLoggedIn: false,
    initial: true, // 프로필 최초 조회 여부
    profile: {}
};

export const getters = {
    isLoggedIn: ({ isLoggedIn }) => isLoggedIn,
    isDeveloper: ({ profile: { isAgreedToTerms } }) => isAgreedToTerms,
    userProfile: ({ profile: { profileImage } }) => profileImage,
    userId: ({ profile: { id } }) => id,
    userEmail: ({ profile: { email } }) => email
};

export const actions = {
    async FETCH_PROFILE({ commit, state: { initial } }) {
        if (initial) commit("SET_INITIAL", false);
        try {
            const { data } = await fetchProfile();
            commit("SET_PROFILE", data);
            commit("SET_IS_LOGGED_IN", true);
        } catch (e) {
            // do nothing
        }
    },
    async LOGOUT({
        rootState: { route: { path } },
        dispatch
    }) {
        try {
            await logout();
            dispatch("RESET_STORE");
            redirect(path, HOME);
        } catch (e) {
            //
        }
    },
    async DELETE_ACCOUNT({ dispatch, getters }) {
        try {
            await Promise.all([dispatch("FETCH_MY_PROJECTS")]);
            const { userEmail, myProjects } = getters;
            const adminProjects = myProjects.filter(
                ({ members }) =>
                    !!members.find(
                        ({ email, role }) =>
                            email === userEmail && role === "ADMIN"
                    )
            );
            const isAdmin = !!adminProjects.length;
            if (isAdmin) {
                const { appsByProjectId } = getters;
                const undeletable = adminProjects.some(
                    ({ members, id }) =>
                        members.length > 1 || appsByProjectId(id).length > 0
                );
                if (undeletable) {
                    return dispatch("CONFIRM_UNDELETABLE");
                }
            }
            dispatch("CONFIRM_DELETE_ACCOUNT", isAdmin);
        } catch (e) {
            //
        }
    },
    CONFIRM_DELETE_ACCOUNT(
        {
            dispatch,
            rootState: { route: { path } }
        },
        isAdmin
    ) {
        dispatch("UPDATE_DIALOG", {
            title: i18n.t("deleteAccount.title"),
            slot: () =>
                import("@/components/dialogs/user/Dialog.deleteAccount.vue"),
            isAdmin,
            confirmed: false,
            actions: [
                { action: "cancel", label: i18n.t("label.cancel") },
                {
                    async_action: "confirm",
                    label: i18n.t("label.delete"),
                    color: "danger",
                    disabled: true
                }
            ],
            confirm: async dialog => {
                try {
                    await deleteAccount();
                    dialog.close();
                    redirect(path, HOME);
                    router.go();
                } catch (e) {
                    dispatch("UPDATE_ERROR_SNACKBAR", e);
                }
            }
        });
    },
    CONFIRM_UNDELETABLE({ dispatch }) {
        return dispatch("UPDATE_DIALOG", {
            title: i18n.t("deleteAccount.title"),
            content: i18n.t("deleteAccount.content.undeletable"),
            actions: [{ action: "confirm", label: i18n.t("label.confirm") }]
        });
    },
    async REGISTER_DEVELOPER({
        dispatch,
        rootState: { route: { path } },
        getters: { userId }
    }) {
        try {
            await registerDeveloper(userId, { agreedToTerms: true });
            await dispatch("FETCH_PROFILE");
            redirect(path, HOME);
        } catch (e) {
            //
        }
    },
    async UNREGISTER_DEVELOPER({ rootState: { route: { path } } }) {
        try {
            await deleteAccount();
            redirect(path, HOME);
            router.go();
        } catch (e) {
            //
        }
    }
};

export const mutations = {
    SET_IS_LOGGED_IN(state, value) {
        state.isLoggedIn = value;
    },
    SET_PROFILE(state, value) {
        state.profile = value;
    },
    SET_INITIAL(state, value) {
        state.initial = value;
    },
    RESET_LOGIN_INFO() {
        state.profile = {};
        state.isLoggedIn = false;
    }
};
